fx.ns("desktop.common.panels", class InfoPanel extends fx.components.PopupPanelNavigation {
	constructor() 
	{
		super();
      	this.destroyOnSwitch = true;
	}

	create() 
    {
		super.create();

		let mainbox = new fx.components.Box("container");

		// title
		this.title = new fx.components.Text({ text: fx.text("Les détails de votre album"), className: "title medium bold" });
		mainbox.addChild(this.title, { width: "100%", left: "center", top: 0 });

		let hbox = new fx.components.HBox("center");

		// size box
		this.sizeBox = new fx.components.Box("size-option");
		this.sizeButton = new fx.components.ImageButton({className : "size-button"});
		this.textSize = new fx.components.Text({ className: "size-title" });
		this.textDimensions = new fx.components.Text({ className: "dimensions" });
		this.textAction = new fx.components.Text({ text: fx.text("Changer la taille"), className: "action" });
		this.sizeBox.addChild(this.sizeButton, { width: 150, height: 150, left: "center", top: 10 });
		this.sizeBox.addChild(this.textSize, { width: "100%", height: 20, bottom: 0, left: 0, top: 180 });
		this.sizeBox.addChild(this.textDimensions, { width: "100%", height: 20, bottom: 0, left: 0, top: 210 });
		this.sizeBox.addChild(this.textAction, { width: "100%", height: 20, bottom: 0, left: 0, top: 240 });
		hbox.addChild(this.sizeBox, { width: "45%", height: 290 });

		// cover box
		this.coverBox = new fx.components.Box("cover-option");
		this.coverButton = new fx.components.ImageButton({className: "cover-button"});
		this.coverTitle = new fx.components.Text({ className: "size-title" });
		this.coverLabel = new fx.components.Text({ className: "dimensions" });
		this.coverAction = new fx.components.Text({ text: fx.text("Changer la couverture"), className: "action" });
		this.coverBox.addChild(this.coverButton, { width: 150, height: 150, left: "center", top: 10 });
		this.coverBox.addChild(this.coverTitle, { width: "100%", height: 20, bottom: 0, left: 0, top: 180 });
		this.coverBox.addChild(this.coverLabel, { width: "100%", height: 20, bottom: 0, left: 0, top: 210 });
		this.coverBox.addChild(this.coverAction, { width: "100%", height: 20, bottom: 0, left: 0, top: 240 });
		hbox.addChild(this.coverBox, { width: "45%", height: 290 });
		mainbox.addChild(hbox, { top: 70, width: "100%", height: "290" })

		// pages infos label
		this.pagesLabel = new fx.components.Text({ className: "label-pages" })

		// total bottom bar
		let totalBar = new fx.components.Box("total");
		let totalLabel = new fx.components.Text({ text: "<span class='bold'>" + fx.text("Total") + "</span> <span class='delivery'>(" + fx.text("hors livraison") + ")</span>", className: "total-label" });
		this.totalValue = new fx.components.Text({ className: "value-label" });
		totalBar.addChild(totalLabel, { left: 20, top: "center" });
		totalBar.addChild(this.totalValue, { right: 20, top: "center" });
		mainbox.addChild(this.pagesLabel, { width: "90%", bottom: 70, left: "center" });
		mainbox.addChild(totalBar, { width: "100%", height: 50, bottom: 0, left: 0 });

		this.addChild(mainbox, { top: "center", left: "center", height: 450, width: "450" });

		// keep previous size / cover when switching to new datas for animations purposes.
		this.previousSize = {};
		this.previousCover = {};

	}

	onReady() {
		super.onReady();

        this._updateComponents();
		// events
		this.on("click", this._chooseFormat, this.sizeBox);
		this.on("click", this._chooseCover, this.coverBox);
		this.listenUpdates(this.data.creation, true);

        /*if (!this.data.configurationEditable('format') )
        {
            this.sizeBox.addClass("not-available")
            this.textAction.hide();
        }

        if (!this.data.configurationEditable('cover') )
        {
            this.coverBox.addClass("not-available")
            this.coverAction.hide();
        }*/
	}

	// Events

	_chooseFormat() {
		this.steps( "shared.screens.SizeAlbum" );
	}

	_chooseCover() {
		this.steps("shared.screens.CoverAlbum", "shared.screens.HardCover");
	}

	onDataUpdated(action) {
		if (action.impacts("formatid")) {
			this._updateComponents();
		}
		else if (action.impacts("cover_option")) {
			this._updateComponents();
		}
	}

	// Animations when switching to new size / cover

	_animateSizeBox(){
		this.sizeBox.hide();
		this.sizeBox.removeClass("disabled");
		this.delay(this._stopAnimateSizeBox, 500);
	}
	
	_animateCoverBox(){
		this.coverBox.hide();
		this.delay(this._stopAnimateCoverBox, 500);
	}

	_stopAnimateSizeBox(){
		this.sizeBox.show();
		this._updateSize();
	}

	_stopAnimateCoverBox(){
		this.coverBox.show();
		this._updateCover();
	}

	// Update components when switching to new size / cover

	_updateSize(){
		this.sizeButton.image = this.data.getFormatAsset();
		this.textSize.text = fx.text(this.data.creationFormat.title_new);
		this.textDimensions.text = fx.text(this.data.creationFormat.description);
		this.totalValue.text = this.data.creation.totalPrice;
		if (this.data.creation.extraPages > 0)
			this.pagesLabel.text = fx.text("Votre album contient $ pages", this.data.creation.numberPages) + "<br>" + fx.text("dont $ pages additionnelles (+$ €)", this.data.creation.extraPages, this.data.creation.pagesPrice.toFixed(2));
		else
			this.pagesLabel.text = fx.text("Votre album contient $ pages", this.data.creation.numberPages);

		this.previousSize.image = this.sizeButton.image;
		this.previousSize.titleText = this.textSize.text;
		this.previousSize.infoText = this.textDimensions.text;
	}

	_updateCover(){
		this.coverButton.image = this.data.creation.getOptionAsset();
		this.coverTitle.text = this.data.creation.coverName;
		this.coverLabel.text = fx.text("De $ à $ pages", this.data.creation.coverChoice.min_pages, this.data.creation.coverChoice.max_pages);
		this.totalValue.text = this.data.creation.totalPrice;
		if (this.data.creation.extraPages > 0)
			this.pagesLabel.text = fx.text("Votre album contient $ pages", this.data.creation.numberPages) + "<br>" + fx.text("dont $ pages additionnelles (+$ €)", this.data.creation.extraPages, this.data.creation.pagesPrice.toFixed(2));
		else
			this.pagesLabel.text = fx.text("Votre album contient $ pages", this.data.creation.numberPages);

		this.previousCover.image = this.coverButton.image;
		this.previousCover.titleText = this.coverTitle.text;
		this.previousCover.infoText = this.coverLabel.text;
	}

	_updateComponents() {

		if(this.previousSize.titleText && (this.previousSize.titleText != fx.text(this.data.creationFormat.title_new)))
		{
			this.sizeButton.image = this.previousSize.image;
			this.textSize.text = this.previousSize.titleText;
			this.textDimensions.text = this.previousSize.infoText;

			this._updateCover();
			this.delay(this._animateSizeBox, 500);
		}
		else if(this.previousCover.titleText && (this.previousCover.titleText != this.data.creation.coverName))
		{
			this.coverButton.image = this.previousCover.image;
			this.coverTitle.text = this.previousCover.titleText;
			this.coverLabel.text = this.previousCover.infoText;

			this._updateSize();
			this.delay(this._animateCoverBox, 500);
		}
		else 
		{
			this._updateSize();
			this._updateCover();
		}

        this.sizeBox.toggleClass("disabled", this.data.creation.cover_option == models.ProductBook.BIND);
	}

    close()
    {
        this.data.event("show-editor");
    }
});
